import _ from 'lodash'
import NumberFormat from 'react-number-format'
import { Input, FormGroup } from 'reactstrap'

import { ErrorFeedback } from 'common-components/view-logic'

const MAX_FORMATTED_LENGTH = 17

const countPlaceholder = (format) => (format.match(/#/g) || []).length

const removeFormatting = (value, format) => {
  if (!format) {
    return value
  }

  const separators = _.uniq(format.split('').filter((char) => char !== '#'))

  return separators.reduce((acc, separator) => acc.split(separator).join(''), value)
}

const applyFormat = (value, format) => {
  if (!format) {
    return value
  }

  const rawValue = value.slice(0, countPlaceholder(format))
  let index = 0
  let formattedValue = ''

  for (const char of format) {
    if (index >= rawValue.length) {
      break
    }

    if (char === '#') {
      formattedValue += rawValue[index]
      index += 1

    } else {
      formattedValue += char
    }
  }

  return formattedValue
}

const CustomNumberInput = (props) => {
  const { id, value, onChange, disabled, decimalPrecision, type, pattern, format, allowNegative, isAllowed } = props
  return (
    <NumberFormat
      id={id}
      isAllowed={isAllowed || (({ formattedValue }) => formattedValue.length <= MAX_FORMATTED_LENGTH)}
      customInput={Input}
      value={value}
      decimalPrecision={decimalPrecision || 0}
      allowNegative={allowNegative || false}
      type={type}
      pattern={pattern}
      format={format}
      onFocus={(e) => e.target.setSelectionRange(0, -1)}
      onChange={onChange}
      disabled={disabled || false}
    />
  )
}

const CustomTextInput = (props) => {
  const { id, value, onChange, disabled, type, pattern, format, isAllowed } = props
  const allowValue = isAllowed || (({ formattedValue }) => formattedValue.length <= MAX_FORMATTED_LENGTH)
  const displayValue = _.isNil(value) ? value : applyFormat(removeFormatting(value, format), format)
  const lastFormattedValue = React.useRef(displayValue || '')

  if (!_.isNil(displayValue)) {
    lastFormattedValue.current = displayValue
  }

  const handleChange = (e) => {
    const el = e.target
    const rawValue = removeFormatting(el.value, format).slice(0, format ? countPlaceholder(format) : undefined)
    const formattedValue = applyFormat(rawValue, format)
    const valueObj = {
      formattedValue,
      value: rawValue,
      floatValue: parseFloat(rawValue.replace(/[^0-9.-]/g, '')),
    }

    if (!allowValue(valueObj)) {
      el.value = lastFormattedValue.current

      return
    }

    el.value = formattedValue
    if (formattedValue === lastFormattedValue.current) {
      return
    }

    lastFormattedValue.current = formattedValue
    onChange(e, valueObj)
  }

  return (
    <Input
      id={id}
      value={displayValue}
      type={type || 'text'}
      pattern={pattern}
      onFocus={(e) => e.target.setSelectionRange(0, -1)}
      onChange={handleChange}
      disabled={disabled || false}
    />
  )
}

const InputWithPotentialError = (props) => {
  const CustomInput = props.isTextInput ? CustomTextInput : CustomNumberInput

  return (
    <div>
      <FormGroup className={`item basic ${_.isEmpty(props.errors) ? '' : 'has-danger'}`}>
        <div className={`${props.className}`}>
          <CustomInput {...props} />
        </div>
        <ErrorFeedback id="coverage-errors" errorMessages={props.errors} />
      </FormGroup>
    </div>
  )
}

const NumberInputSearch = (props) => {
  const { Number, validatetion, type, pattern, format, id, isTextInput } = props

  return (
    <InputWithPotentialError
      {...props}
      id={id}
      type={type || (isTextInput ? 'text' : 'tel')}
      pattern={isTextInput ? pattern : pattern || '[0-9]*'}
      format={format || null}
      className="loan-amount"
      value={isTextInput && _.isNil(Number) ? props.value : Number}
      errors={validatetion.filter((valError) => valError.isValid == true).map((v) => v.errorMessage)}
    />
  )
}

export default NumberInputSearch
